import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import AttributeContainingTextInput from '../../../editor/components/AttributeContainingTextInput/AttributeContainingTextInput';
import { StoreState } from '@mm/state/store-interfaces';
import AttributePicker from '../../components/AttributePicker/AttributePicker';
import CheckBox from '../../components/Checkbox';
import { EmojiPicker } from '../../components/EmojiPicker/EmojiPicker';
import Input from '../../components/Input/Input';
import { useEmailWidgetHandlers } from '../../helpers/widget-helpers/use-email-widget-handlers';
import { EmailWidgetProps } from './EmailWidget';

export const EmailNotification = (props: EmailWidgetProps) => {
  const { isExpanded } = props;
  const {
    toValue,
    replyValue,
    onChangeReply,
    subjectValue,
    bodyValue,
    onChangeTo,
    onChangeSubject,
    onChangeBody,
    onBlur,
    updateInsertEmojiBody,
    setEmailBodyRef,
    setEmailSubjectRef,
    updateInsertEmojiSubject,
    updateInsertAttributeBody,
    isReplyEmailValid,
    isToEmailValid,
    updateInsertAttributeSubject,
    markAsFollowUpValue,
    updateMarkAsFollowUp,
  } = useEmailWidgetHandlers(props);

  const attributes = useSelector(
    (state: StoreState) => state.attribute.entities,
  );

  return isExpanded ? (
    <div
      className={classnames(
        'email-widget__wrapper',
        'email-widget--startbots-layout',
      )}
    >
      <div className="email-widget__container">
        <div className="email-widget__input-container">
          <div className="email-widget__input-title">Reply to email</div>
          <div>
            <Input
              value={replyValue}
              onChange={onChangeReply}
              onBlur={onBlur}
              placeholder="Enter reply to email"
            />
            {!isReplyEmailValid && (
              <div className="email-widget__email-error">Not Valid Email</div>
            )}
          </div>
        </div>
      </div>
      <div className="email-widget__container">
        <div className="email-widget__input-container">
          <div className="email-widget__input-title">To (comma-separated)</div>
          <div>
            <AttributeContainingTextInput
              className="email-widget__input email-widget__input--to"
              multiline
              autosize={false}
              value={toValue}
              onChange={onChangeTo}
              onBlur={onBlur}
              placeholder="Enter recipient"
            />
            {!isToEmailValid && (
              <div className="email-widget__email-error">Not Valid Email</div>
            )}
          </div>
        </div>
      </div>
      <div className="email-widget__container">
        <div className="email-widget__input-container">
          <div className="email-widget__input-title">
            <span>Subject</span>
            <div className="widget-common__heading widget-common__icons-container email-widget__top-container">
              <AttributePicker
                color="#9b9b9b"
                className="email-widget__attribute-picker"
                onAttributePicked={updateInsertAttributeSubject}
              />
              <EmojiPicker
                className="email-widget__emoji-picker"
                onEmojiPicked={updateInsertEmojiSubject}
              />
            </div>
          </div>
          <div>
            <AttributeContainingTextInput
              className="email-widget__input"
              value={subjectValue}
              onChange={onChangeSubject}
              onBlur={onBlur}
              attributes={attributes}
              placeholder="Enter subject"
              inputRef={setEmailSubjectRef}
            />
          </div>
        </div>
      </div>
      <div className="email-widget__container">
        <div className="email-widget__input-container">
          <div className="email-widget__input-title">
            <span>Body</span>
            <div className="widget-common__heading widget-common__icons-container email-widget__top-container">
              <AttributePicker
                className="email-widget__attribute-picker"
                onAttributePicked={updateInsertAttributeBody}
                color="#9b9b9b"
              />
              <EmojiPicker
                className="email-widget__emoji-picker"
                onEmojiPicked={updateInsertEmojiBody}
              />
            </div>
          </div>
          <div>
            <AttributeContainingTextInput
              className="email-widget__input email-widget__input--body"
              multiline
              autosize={false}
              value={bodyValue}
              onChange={onChangeBody}
              onBlur={onBlur}
              attributes={attributes}
              placeholder="Enter you message here"
              inputRef={setEmailBodyRef}
            />
          </div>
        </div>
      </div>
      <div className="email-widget__mark-as-follow-up">
        <CheckBox
          label="Mark conversation as follow up"
          isChecked={markAsFollowUpValue}
          onClick={e => updateMarkAsFollowUp(!markAsFollowUpValue)}
        />
      </div>
    </div>
  ) : subjectValue ? (
    <div className="widget-component__collapsed-content">{subjectValue}</div>
  ) : null;
};
